document.addEventListener('DOMContentLoaded', () => {
  const mount = document.getElementById('hostaway-calendar-widget');
  if (!mount) return;

  const card = document.querySelector('section.hwc-card');
  const originalParent = card?.parentNode || null;
  const originalNextSibling = card?.nextElementSibling || null;
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  const placeCardBeforeReviews = () => {
    if (!card) return;

    if (!mobileQuery.matches) {
      if (card.dataset.hwcMoved === 'true' && originalParent) {
        originalParent.insertBefore(card, originalNextSibling);
        delete card.dataset.hwcMoved;
      }
      return;
    }

    if (card.dataset.hwcMoved === 'true') return;

    const reviewHeading = Array.from(document.querySelectorAll('h1, h2, h3, h4, h5'))
      .find(node => /reviews/i.test(node.textContent.trim()));

    const reviewsSection = reviewHeading ? reviewHeading.closest('section, article, div') : null;
    if (reviewsSection && reviewsSection.parentNode) {
      reviewsSection.parentNode.insertBefore(card, reviewsSection);
      card.dataset.hwcMoved = 'true';
    }
  };

  mobileQuery.addEventListener('change', placeCardBeforeReviews);
  placeCardBeforeReviews();

  const init = () => {
    if (typeof window.hostawayCalendarWidget !== 'function') {
      window.setTimeout(init, 120);
      return;
    }

    window.hostawayCalendarWidget({
      container_id: 'hostaway-calendar-widget',
      baseUrl: 'https://brandywinegrove.holidayfuture.com/',
      listingId: 209051,
      numberOfMonths: 1,
      openInNewTab: false,
      rounded: true,
      clearButtonText: 'Clear dates',
      button: {
        action: 'checkout',
        text: 'Confirm dates'
      },
      color: {
        mainColor: '#795e4a',
        frameColor: '#795e4a',
        textColor: '#2f2a26'
      },
      font: 'Lato'
    });
  };

  init();
});

// --- Mobile-only: remove Hostaway inline top padding and button margins dynamically ---
(function () {
  function killHostawayTopPaddingAndMargins() {
    if (window.innerWidth >= 768) return; // only run on mobile
    const root = document.getElementById('hostaway-calendar-widget');
    if (!root) return;

    // Remove inline and computed padding from all Hostaway wrappers
    const nodes = root.querySelectorAll('div[style*="padding-top"], [class*="Wrapper"]');
    nodes.forEach(el => {
      const pt = parseInt(getComputedStyle(el).paddingTop) || 0;
      if (pt > 0) el.style.setProperty('padding-top', '0px', 'important');
      el.style.setProperty('margin-top', '0px', 'important');
    });

    // Remove horizontal margins from Previous/Next buttons
    const prevBtn = root.querySelector('button[aria-label*="Previous"]');
    const nextBtn = root.querySelector('button[aria-label*="Next"]');
    if (prevBtn) {
      prevBtn.style.setProperty('margin-left', '0px', 'important');
      prevBtn.style.setProperty('margin-right', '0px', 'important');
      prevBtn.style.setProperty('left', '0px', 'important');
      prevBtn.style.setProperty('right', 'auto', 'important');
    }
    if (nextBtn) {
      nextBtn.style.setProperty('margin-left', '0px', 'important');
      nextBtn.style.setProperty('margin-right', '0px', 'important');
      nextBtn.style.setProperty('right', '0px', 'important');
      nextBtn.style.setProperty('left', 'auto', 'important');
    }
  }

  // Run immediately + observe re-renders
  const boot = () => {
    killHostawayTopPaddingAndMargins();
    const target = document.getElementById('hostaway-calendar-widget');
    if (!target) return;

    // Observer re-applies fix if Hostaway re-renders calendar (month switch etc.)
    const mo = new MutationObserver(killHostawayTopPaddingAndMargins);
    mo.observe(target, { childList: true, subtree: true });

    // Ensure it stays fixed on resize
    window.addEventListener('resize', killHostawayTopPaddingAndMargins);
  };

  // Run after DOM ready or Shopify section reload
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
